module.exports = true;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/$.library.js
// module id = ./node_modules/core-js/library/modules/$.library.js
// module chunks = 2